import { collection, getDocs, orderBy, query } from 'firebase/firestore';
import Failure from '../../../core/Failure';
import { FirestoreCollections, firestore } from '../../../firebase.config';
import { ICompany } from '@leedpulse-monorepo/interfaces';

async function getCompaniesBySubscriptionId(subscriptionId: string): Promise<ICompany[]> {
  try {
    const db = firestore;

    const companiesCollection = collection(db, FirestoreCollections.companies);
    const results = await getDocs(query(companiesCollection, orderBy(`id_subscriptions.${subscriptionId}`, 'asc')));

    const companies: ICompany[] = [];

    results.forEach((doc) => {
      companies.push(doc.data() as ICompany);
    });

    return companies;
  } catch (e) {
    console.error('error: ', e);
    throw new GetCompaniesBySubscriptionIdFailure();
  }
}

export class GetCompaniesBySubscriptionIdFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default getCompaniesBySubscriptionId;
